import React, { useTransition } from 'react';
import { useTranslation } from 'react-i18next';
import { FaChartBar, FaUsers, FaFileAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Button, Card } from 'react-bootstrap';

const PhishingCampaigns = () => {
  
  const { t } = useTranslation();
  const navigate = useNavigate();
  const goToPhishingCampaignusersdashboard = () => {
    navigate('/PhishingCampaignusersdashboard');
  };
  const goToPhishingCampaignSummary = () => {
    navigate('/PhishingCampaignSummary');
  };
  const goToPhishingCampaignsProgress = () => {
    navigate('/PhishingCampaignsProgress');
  };
  return (
    <div className='container mt-4'>
      <div className="d-flex justify-content-between align-items-center mb-3">
      <h1 className='textAwareness mb-4'>{t('PhishingReports')}</h1>
  <Button
    variant="primary"
    className="mb-3"
    onClick={() => navigate(-1)}
  >
    {t('Back')}
  </Button>
</div>
      <div className='row g-4'>
        <div className='col-md-4'>
          <div className='card text-center shadow-sm h-100'>
            <div className='card-body d-flex flex-column align-items-center'>
              <div style={{ fontSize: '2.5rem', color: '#6c757d' }}>
                <FaChartBar />
              </div>
              <h6 className='card-title mt-3'>{t('PhishingCampaignsummarydashboard')}</h6>
              <button className='btn btn-primary mt-3' onClick={goToPhishingCampaignSummary}>
                {t('View')}
              </button>
            </div>
          </div>
        </div>

        <div className='col-md-4'>
          <div className='card text-center shadow-sm h-100'>
            <div className='card-body d-flex flex-column align-items-center'>
              <div style={{ fontSize: '2.5rem', color: '#6c757d' }}>
                <FaUsers />
              </div>
              <h6 className='card-title mt-3'>{t('PhishingCampaignusersdashboard')}</h6>
              <button className='btn btn-primary mt-3' onClick={goToPhishingCampaignusersdashboard}>
                {t('View')}
              </button>
            </div>
          </div>
        </div>

        <div className='col-md-4'>
          <div className='card text-center shadow-sm h-100'>
            <div className='card-body d-flex flex-column align-items-center'>
              <div style={{ fontSize: '2.5rem', color: '#6c757d' }}>
                <FaFileAlt />
              </div>
              <h6 className='card-title mt-3'>{t('PhishingCampaignsProgressDashboard')}</h6>
              <button className='btn btn-primary mt-3' onClick={goToPhishingCampaignsProgress}>
                {t('View')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhishingCampaigns;
